export default __webpack_public_path__ + "static/media/Ashley 9781408303498.d006e935.jpg";